// Drawn neighbours still in draft (art/aseprite/src/neighbour_heads.lua): their heads are on the sheet, but no visitor mix picks them.
// The demo shows one at the door with &head=<name>.
export const DRAFTS = ['crab', 'mole'];
